// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./link.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._2LbllS4Rx{position:relative;color:var(--primary-text);padding:8px 15px 8px 13px;margin:4px 0}._2LbllS4Rx:hover{color:var(--primary-text);background-color:var(--ui-subtle-hover)}._2LbllS4Rx._5SCoWZqjx{font-weight:bold}._2LbllS4Rx._5SCoWZqjx._5K2tWo6ox{background-color:var(--ui-subtle-active)}._2LbllS4Rx._5SCoWZqjx._5K2tWo6ox:hover{background-color:var(--ui-subtle-active-hover)}._63WJDPVnx{}._63WJDPVnx::before{display:none;top:8px;bottom:8px}._63WJDPVnx._5SCoWZqjx::before{display:block}._4M2tQZHOx{margin-left:10px}._1sot5nKex{}._39TTGdbEx{padding:2px}._5uIxMQTYx{margin-left:13px;white-space:nowrap}._1sot5nKex:not(._1Z6hpBWsx) ._5uIxMQTYx{opacity:0}@media screen and (-ms-high-contrast: active){._5uIxMQTYx{-ms-high-contrast-adjust:none}}._4nf7Sj0rx{position:absolute;left:36px;top:0;bottom:0;margin:auto;z-index:2;display:none}._5SCoWZqjx ._4nf7Sj0rx{display:block}._1Z6hpBWsx ._4nf7Sj0rx{display:none}@media screen and (-ms-high-contrast: active){._4nf7Sj0rx path{fill:buttonText}}._39TTGdbEx{}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"top-level-link": "_2LbllS4Rx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["paragraph-m"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["link"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["focus-outline"] + "",
	"topLevelLink": "_2LbllS4Rx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["paragraph-m"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["link"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["focus-outline"] + "",
	"active": "_5SCoWZqjx",
	"no-children": "_5K2tWo6ox",
	"noChildren": "_5K2tWo6ox",
	"with-active-indicator": "_63WJDPVnx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["with-active-indicator"] + "",
	"withActiveIndicator": "_63WJDPVnx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["with-active-indicator"] + "",
	"tooltip": "_4M2tQZHOx",
	"link-content": "_1sot5nKex " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"linkContent": "_1sot5nKex " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"icon": "_39TTGdbEx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["transition-opacity"] + "",
	"link-text": "_5uIxMQTYx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["transition-opacity"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"linkText": "_5uIxMQTYx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["transition-opacity"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"expanded": "_1Z6hpBWsx",
	"chevron": "_4nf7Sj0rx"
};
module.exports = exports;
